// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import PageEvents from './PageEvents'
import Editable from 'components/Editable/Editable'
import ContentBox from 'components/ContentBox/ContentBox'
import Recaptchas from 'components/Recaptchas/Recaptchas'
// import PageHeader from './PageHeader'
import Content from './Content'
import Resources from './Resources'
import Attachments from './Attachments'
import Posts from './Posts'

// Redux:
import { getPageData } from 'actions/page'

const host = window.location.host

class Page extends React.Component {
	componentDidMount() {
		if ( ! this.props.match ) {
			return
		}

		window.scrollTo( 0, 0 )

		const { params, path } = this.props.match

		if ( this.props.home ) {
			this.props.getPost( 'home', 'page' )
		} else if ( params.page ) {
			if ( params.archivePageNumber ) {
				this.props.getPost( params.page, 'page', params.archivePageNumber )
			} else {
				this.props.getPost( params.page, 'page' )
			}
		} else if ( params.blog ) {
			this.props.getPost( params.blog, 'post' )
		} else if ( params.blogCategory ) {
			this.props.getPost( params.blogCategory, 'post-category' )
		} else if ( params.resource ) {
			this.props.getPost( params.resource, 'resource' )
		} else if ( params.category ) {
			this.props.getPost( params.category, 'resource-category' )
		}
	}

	componentDidUpdate( prevProps, prevState ) {
		if ( ! this.props.match ) {
			return
		}

		window.scrollTo( 0, 0 )

		let pageChanged = false

		const { params, path } = this.props.match
		const prevParams = prevProps.match.params
		const prevPath = prevProps.match.path

		if ( this.props.home && ! prevProps.home ) {
			this.props.getPost( 'home', 'page' )
		} else if ( params.page && prevParams.page !== params.page ) {
			this.props.getPost( params.page, 'page' )
		} else if ( params.page && params.archivePageNumber && prevParams.archivePageNumber !== params.archivePageNumber ) {
			this.props.getPost( params.page, 'page', params.archivePageNumber )
		} else if ( params.blog && prevParams.blog !== params.blog ) {
			this.props.getPost( params.blog, 'post' )
		} else if ( params.blogCategory && prevParams.blogCategory !== params.blogCategory ) {
			this.props.getPost( params.blogCategory, 'post-category' )
		} else if ( params.resource && prevParams.resource !== params.resource ) {
			this.props.getPost( params.resource, 'resource' )
		} else if ( params.category && prevParams.category !== params.category ) {
			this.props.getPost( params.category, 'resource-category' )
		}
	}

	renderLoading() {
		return (
			<div className="primary-content-inner primary-content-is-loading">

			</div>
		)
	}

	renderContent() {
		const { page } = this.props

		if ( ! page ) {
			return null
		}

		document.title = page.title.raw

		const pageContent = page.html_override ? (
			<div className="content-custom-wrap" dangerouslySetInnerHTML={ { __html: page.html_override } }></div>
		) : (
			<div>
				<Content />

				<Resources />
				<Attachments />
				<Posts
					location={ this.props.location }
					match={ this.props.match }
				/>
			</div>
		)

		return (
			<div className="primary-content-inner primary-content-is-ready">
				<PageEvents />

				{ pageContent }

				<Recaptchas />
			</div>
		)
	}

	render() {
		return (
			<div>
				{ this.props.page.isLoading ? this.renderLoading() : this.renderContent() }
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {
		getPost: ( slug, type, archivePageNumber ) => {
			dispatch( getPageData( slug, type, archivePageNumber ) )
		}
	}
}

export default connect( mapStateToProps, mapDispatchToProps )( Page )



// WEBPACK FOOTER //
// ./views/main/page/Page.jsx